import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'document-register-element/build/document-register-element';
import vueCustomElement from 'vue-custom-element'

// Require auto-polyfill
require('es6-promise/auto');

Vue.use(Vuetify)
Vue.use(vueCustomElement)

// Import Tavolos Component
import TavolosWidget from './components/TavolosWidget.vue'
import './stylus/main.styl'
require('./assets/css/fonts.css')
require('./assets/css/main.css')

// Google Analytics
typeof ga === undefined ? window.ga = {} : ''
if (window.ga) {
  ga('create', 'UA-104907836-3', 'auto', 'tavolos');
  ga('tavolos.send', 'pageview');
}

// Import JQuery
import $ from 'jquery'
window.tQuery = $
window.$t = $

// Make universal component for embedded into another website
// Configure Vue to ignore the element name when defined outside of Vue.
Vue.config.ignoredElements = [
  'tavolos-widget'
]

// Register your component
Vue.customElement('tavolos-widget', TavolosWidget, {
  // Additional Options: https://github.com/karol-f/vue-custom-element#options
})

// Add default page for testing
new Vue({
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js